const { VITE_WEBSITE_DOMAIN: websiteDomain } = import.meta.env;

const routes = {
  HOME: '/',
  UNAUTHORISED: '/unauthorised',
  NOT_FOUND: '/not-found',
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_DEV: '/register-dev',
  RESET_PASSWORD: '/reset-password',
  CHANGE_PASSWORD: '/change-password',
  CHANGE_PASSWORD_SUCCESS: '/change-password-success',
  SURVEY: '/survey',
  STORYBOOK: '/storybook',
  APP_HOME: `${websiteDomain}`,
  COMPLETE_PAYMENT: '/complete-payment',
  FAQ: '/faq',
  SUBMIT_SURVEY_SUCCESS: '/submit-survey-success',
  VIEW_REPORT: '/view-report/:salesforceContactId'
};

export default routes;
